import React from "react";

export default function InsurancePlans() {
  const insuranceOffers = [
    { monthlyCredit: 1500, duration: "60 Months", totalCredit: 90000, maturityMonths: 84, payoutAmount: 130000 },
    { monthlyCredit: 2000, duration: "60 Months", totalCredit: 120000, maturityMonths: 84, payoutAmount: 170000 },
  ];

  return (
    <div className="container mt-4">
      {/* <h3 className="text-center">Insurance Plans</h3> */}
      <p className="text-center text-info fw-bold rounded p-2 shadow" style={{ maxWidth: "850px", background: "#d6d6d6", color: "#333", margin: "20px auto", fontSize: "16px", border: "2px solid #888", letterSpacing: "0.5px" }}>
        💡 *Note: Monthly credits must be made consistently for the entire duration to qualify for the payout.
      </p>
      <p>Comprehensive insurance plans for your peace of mind.</p>
      
      <table className="table table-striped text-center">
        <thead>
          <tr className="table-header">
            <th className="tab-header">Monthly Credit (₹)</th>
            <th className="tab-header">Credit Duration</th>
            <th className="tab-header">Total Credit (₹)</th>
            <th className="tab-header">Maturity Period (Months)</th>
            <th className="tab-header">Payout Amount (₹)</th>
          </tr>
        </thead>
        <tbody>
          {insuranceOffers.map((offer, index) => (
            <tr key={index}>
              <td>{offer.monthlyCredit}</td>
              <td>{offer.duration}</td>
              <td>{offer.totalCredit}</td>
              <td>{offer.maturityMonths}</td>
              <td>{offer.payoutAmount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
